import React, { useState, useEffect } from 'react';

const RequestQuote = ({ selectedTech }) => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    phone: '',
    email: '',
    inquiryFor: selectedTech || '',
    description: ''
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (selectedTech) {
      setFormData(prev => ({ ...prev, inquiryFor: selectedTech }));
    }
  }, [selectedTech]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.organization.trim()) newErrors.organization = 'organization is required'
    if (!formData.inquiryFor.trim()) newErrors.inquiryFor = 'Please Select One Fileds '
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    try {
      // Add a "type" to formData before sending
      const payload = {
        ...formData,
      };

      const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(payload).toString(),
      });

      const result = await response.json();
      alert('Form submitted successfully!');
       setFormData({
        name: '',
        organization: '',
        phone: '',
        email: '',
        inquiryFor: '',
        description: ''
      });
      setMessage('Message sent successfully!');
      setErrors({});
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    }
    // if (Object.keys(newErrors).length === 0) {
    //   setMessage('Message sent successfully!');
    //   console.log('Form Submitted:', formData);
    //   setFormData({
    //     name: '',
    //     organization: '',
    //     phone: '',
    //     email: '',
    //     inquiryFor: '',
    //     description: ''
    //   });
    // } else {
    //   setMessage('');
    // }
  };

  const handleReset = () => {
    setFormData({
      name: '',
      organization: '',
      phone: '',
      email: '',
      inquiryFor: '',
      description: ''
    });
    setErrors({});
    setMessage('');
  };

  return (
    <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
      <h2 data-aos="fade-up" className="text-[54px] lg:text-4xl text-center font-bold text-[#002856] mb-8 font-recoleta">
        Ready To Request a Quote?
      </h2>

      {message && (
        <div className="mb-4 text-green-600 font-semibold text-center">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <input
              data-aos="fade-up"
              name="name"
              placeholder="Name *"
              className="w-full border border-gray-300 lg:p-4 p-8 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <p className="text-red-500 lg:text-sm text-[24px]">{errors.name}</p>}
          </div>

          <div>
            <input
              data-aos="fade-up"
              name="organization"
              placeholder="Organization Name"
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              value={formData.organization}
              onChange={handleChange}
            />
            {errors.organization && <p className="text-red-500 lg:text-sm text-[24px]">{errors.organization}</p>}
          </div>

          <div>
            <input
              data-aos="fade-up"
              name="phone"
              placeholder="Phone"
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              value={formData.phone}
              onChange={handleChange}
            />
            {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

          </div>
          <div>
            <input
              data-aos="fade-up"
              name="email"
              placeholder="Email *"
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
          </div>

          {/* <div>
            <label className="block text-gray-700 mb-1 text-[28px] lg:text-[20px]">Inquiry For</label>
            <select
              name="inquiryFor"
              data-aos="fade-up"
              value={formData.inquiryFor}
              onChange={handleChange}
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
            >
              <option value="">Select</option>
              <option value="Website">Website</option>
              <option value="App">App</option>
              <option value="Other">Other</option>
            </select>
            {errors.inquiryFor && <p className="text-red-500 text-[24px] lg:text-sm">{errors.inquiryFor}</p>}
          </div> */}
          <div>
            <label className="block text-gray-700 mb-1 text-[28px] lg:text-[20px]">Inquiry For</label>
            <input
              name="inquiryFor"
              data-aos="fade-up"
              value={formData.inquiryFor}
              onChange={handleChange}
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              placeholder="Inquiry For *"
            />
            {errors.inquiryFor && <p className="text-red-500 text-[24px] lg:text-sm">{errors.inquiryFor}</p>}
          </div>

          <div className="lg:col-span-2">
            <textarea
              data-aos="fade-up"
              name="description"
              placeholder="Describe Your Requirement"
              className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
              value={formData.description}
              onChange={handleChange}
              rows={4}
            />
          </div>
        </div>

        <div className="justify-center gap-4 mt-6 grid grid-cols-2 px-10  lg:hidden">
          <button
            type="submit"
            className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
          >
            Send Message
          </button>
          <button
            type="button"
            data-aos="fade-up"
            onClick={handleReset}
            className="bg-[#00447b] w-full text-white lg:mt-0 mt-4 py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
          >
            Reset
          </button>
        </div>
        <div className="justify-center gap-4 mt-6 lg:flex px-10 lg:block hidden">
          <button
            type="submit"
            data-aos="fade-up"
            className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
          >
            Send Message
          </button>
          <button
            type="button"
            data-aos="fade-up"
            onClick={handleReset}
            className="bg-[#00447b] lg:w-52 w-full text-white lg:mt-0 mt-4 py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default RequestQuote;
